import React from "react";

import { DatePicker } from "antd";

import moment from "moment";

const { RangePicker } = DatePicker;

function disabledDate(current) {
  // Can not select days after today and today
  return current && current > moment().endOf("day");
}

export default function PickerWithType({ type, onChange, defaultValue }) {
  if (type === "range")
    return (
      <RangePicker
        showToday
        disabledDate={disabledDate}
        onChange={onChange}
        defaultValue={defaultValue}
      />
    );

  if (type === "date")
    return (
      <DatePicker showToday disabledDate={disabledDate} onChange={onChange} />
    );

  return (
    <DatePicker disabledDate={disabledDate} picker={type} onChange={onChange} />
  );
}
